const BranchContact = () => {
  const branchList = [
    {
      img: "/images/branch1.png",
      num: "010-5135-6262",
    },
    {
      img: "/images/branch2.png",
      num: "010-5957-7144",
    },
    {
      img: "/images/branch3.png",
      num: "010-6647-7733",
    },
    {
      img: "/images/branch4.png",
      num: "010-8284-6782",
    },
    {
      img: "/images/branch5.png",
      num: "010-9390-3056",
    },
    {
      img: "/images/branch6.png",
      num: "010-8969-3721",
    },
    {
      img: "/images/branch7.png",
      num: "010-5238-8266",
    },
    {
      img: "/images/branch8.png",
    },
    {
      img: "/images/branch8.png",
    },
  ];
  return (
    <div className="relative w-full h-full px-2 lg:px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center">
      <div className=" relative w-full h-full grid grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-5">
        {branchList.map((v, i) => (
          <div
            onClick={() =>
              v.num
                ? (window.location.href = "tel:" + v.num)
                : (window.location.href = "/#branch")
            }
            className="cursor-pointer lg:hover:-translate-y-2 lg:hover:shadow-2xl transition-all duration-150"
          >
            <img src={v.img} alt="전국 유품정리 특수청소 서비스 홈페이지" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BranchContact;
